import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=65424b7f&scoped=true"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&id=65424b7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65424b7f",
  null
  
)

export default component.exports